export interface PersistedMyVWSession {
  token: string;
  vwfsToken: string;
  partyId: number | null;
  accountNumber: string | null;
  email: string;
  isLinked: boolean | null;
  brand: string;
  country: string;
  loginAuthenticatorCode: string;
  username: string;
}

const SESSION_STORAGE_KEY = 'myvw.session';

const parsePartyId = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const toPersistedMyVWSession = (state: {
  token: string;
  vwfsToken: string;
  partyId: number | null;
  email: string;
  accountNumber: string;
  isLinked: boolean | null;
  brand: string;
  country: string;
  loginAuthenticatorCode: string;
  username: string;
}): PersistedMyVWSession => ({
  token: state.token,
  vwfsToken: state.vwfsToken,
  partyId: state.partyId,
  email: state.email,
  accountNumber: state.accountNumber,
  isLinked: state.isLinked,
  brand: state.brand,
  country: state.country,
  loginAuthenticatorCode: state.loginAuthenticatorCode,
  username: state.username
});

export const persistMyVWSession = (state: {
  token: string;
  vwfsToken: string;
  partyId: number | null;
  email: string;
  accountNumber: string;
  isLinked: boolean | null;
  brand: string;
  country: string;
  loginAuthenticatorCode: string;
  username: string;
}): void => {
  if (typeof window === 'undefined') return;
  try {
    const persisted = toPersistedMyVWSession(state);
    window.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(persisted));
  } catch {
    // no-op when storage is not available
  }
};

export const hydrateMyVWSession = (): PersistedMyVWSession | null => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return {
      token: parsed?.token ?? '',
      vwfsToken: parsed?.vwfsToken ?? '',
      partyId: parsePartyId(parsed?.partyId),
      email: parsed?.email ?? '',
      accountNumber: parsed?.accountNumber ?? '',
      isLinked: typeof parsed?.isLinked === 'boolean' ? parsed.isLinked : null,
      brand: parsed?.brand ?? '',
      country: parsed?.country ?? '',
      loginAuthenticatorCode: parsed?.loginAuthenticatorCode ?? '',
      username: parsed?.username ?? '',
    };
  } catch {
    return null;
  }
};

export const clearMyVWSession = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(SESSION_STORAGE_KEY);
  } catch {
    // no-op when storage is not available
  }
};
